import { useEffect } from "react"
import { create as createStore } from "zustand"

export function createAsyncGlobalState<T>({
  initialize,
  initialValue,
}: {
  initialize: () => Promise<T>
  initialValue: T
}) {
  const store = createStore<{
    loading: boolean
    data: T
  }>(() => ({
    loading: false,
    data: initialValue,
  }))

  let fetched = false

  return () => {
    useEffect(() => {
      if (!fetched) {
        fetched = true
        store.setState({ loading: true })
        initialize().then((data) => {
          store.setState({ loading: false, data })
        })
      }
    }, [initialize])

    return store()
  }
}
